import { Cover } from '../../components/cover/cover';
import { GeneralLayout } from '../../components/general-layout/general-layout';
import texts from './index.texts.json';
import styles from './index.module.scss';
import { ContactUs } from '../../features/contact-us/contact-us';
import { assetsBasePath } from '../../services/assets';
import env from '@y2/environments';
import { useRouter } from 'next/router';
import { ContactUsBreadcrumbs } from '../../features/contact-us-breadcrumbs/contact-us-breadcrumbs';
import { MetaTags } from '../../components/meta-tags/meta-tags';
import { useUserDetails } from '@y2/auth-common/user-details-query';
import { CLIENT_QUERY_KEYS } from '../../services/params/consts';
import { useEffect } from 'react';
import { pushPageEvent } from '../../features/analytics/feed-events';

const ContactUsPage = () => {
  const router = useRouter();
  const { data: user, isLoading } = useUserDetails();
  const pageNumber = router.query[CLIENT_QUERY_KEYS.PAGE] as string;

  useEffect(() => {
    if (isLoading) return;

    pushPageEvent('publisher_form', user?.id);
  }, [isLoading, pageNumber, user?.id]);
  return (
    <>
      <MetaTags
        metaTitle={`${texts.publishWithUs} | ${texts.metaTitlePrefix}`}
        metaDescription={texts.metaDescription}
        canonicalUrl={`${env.routes.mainSite}${router.basePath}${router.pathname}`}
        robotContent="follow,index"
      />
      <GeneralLayout>
        <Cover
          className={styles.cover}
          bgImage={`${assetsBasePath}contact-cover.jpg`}
          pageHeading={texts.publishWithUs}
        />
        <ContactUs />
        <ContactUsBreadcrumbs />
      </GeneralLayout>
    </>
  );
};

export default ContactUsPage;
